import React from 'react';
import {get} from 'lodash';
import axios from 'axios';

import GroupMember from './GroupMember';

class GroupMembers extends React.Component {
  state = {
    admins: [],
    groupUsers: []
  }

  getAdmins = () => {
    axios.get(`/${gon.currentProvider}/api/group_users`, {
      params: {
        group_id: get(this.props, 'groupId'),
        exclude_id: get(this.props, 'user.id'),
        user_type: 'admin',
      }
    })
    .then((res) => {
      if (res.status == 200 && get(res, 'data')) {
        this.setState({ admins: res.data['groupUsers'] })
      }
    })
  }

  getNormalMembers = () => {
    axios.get(`/${gon.currentProvider}/api/group_users`, {
      params: {
        group_id: get(this.props, 'groupId'),
        exclude_id: get(this.props, 'user.id'),
        per: 11 - this.state.admins.length,
        user_type: 'normal',
      }
    })
    .then((res) => {
      if (res.status == 200 && get(res, 'data')) {
        this.setState({ groupUsers: res.data['groupUsers'] })
      }
    })
  }

  componentDidMount() {
    this.getAdmins()
    this.getNormalMembers()
  }

  render() {
    return (
      <div className='Table Table--group-2'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>User</div>
          <div className='Table__col Table__col--th' />
          <div className='Table__col Table__col--th'>Tool</div>
        </div>

        <div className='Table__row'>
          <div className='Table__col Table__col--span-3'>
            <div className='User__search'>
              <input type='text' placeholder='Chat or user ID' />
              <button type='submit'>Search</button>
            </div>
          </div>
        </div>

        <GroupMember
          role='Owner'
          user={get(this.props, 'user')}
          groupId={get(this.props, 'groupId')}
        />

        {get(this.state, 'admins', []).map((admin) => (
          <GroupMember
            role='Admin'
            user={admin}
            key={admin.id}
            groupId={get(this.props, 'groupId')}
          />
        ))}

        {get(this.state, 'groupUsers', []).map((member) => (
          <GroupMember
            role='Member'
            user={member}
            key={member.id}
            groupId={get(this.props, 'groupId')}
          />
        ))}

        <div className='Table__row'>
          <div className='Table__col Table__col--span-3'>
            <a className='Table__a' href={`/${gon.currentProvider}/group_users?group_id=${get(this.props, 'groupId')}`}>View all</a>
          </div>
        </div>
      </div>
    );
  }
}

export default GroupMembers
